const sectionSelector = '.form-section';

// Gap kept above the scroll target, replaces the values WPForms hardcodes
const scrollGap = 24;

// WPForms passes a ready number to animateScrollTop, not a node, so the target
// is resolved back by matching the value against its own hardcoded gaps
const wpformsTargets = [
    { gap: 100, selector: '.wpforms-error-container, .wpforms-confirmation-scroll' },
    { gap: 75, selector: '.wpforms-field' },
];

let patched = false;

const getHeaderOffset = () => {
    const header = document.querySelector('.site-header');

    if (!header) return 0;

    const position = getComputedStyle(header).position;

    if (position !== 'fixed' && position !== 'sticky') return 0;

    return header.getBoundingClientRect().height;
};

const getDocumentTop = (element) => element.getBoundingClientRect().top + window.scrollY;

const normalizeOffset = (offset) => {
    for (const { gap, selector } of wpformsTargets) {
        for (const element of document.querySelectorAll(selector)) {
            const top = getDocumentTop(element);

            if (Math.abs(top - gap - offset) <= 2) return top - scrollGap;
        }
    }

    // page change and anything else keeps its own offset
    return offset;
};

// WPForms scrolls to errors and to the confirmation with jQuery animate({scrollTop}),
// so scroll-margin-top has no effect — the offset has to be corrected at the source
const patchScrollTop = () => {
    if (patched) return true;

    const api = window.wpforms;

    if (!api || typeof api.animateScrollTop !== 'function') return false;

    const original = api.animateScrollTop;

    api.animateScrollTop = function (offset, duration, complete) {
        return original.call(this, normalizeOffset(parseFloat(offset)) - getHeaderOffset(), duration, complete);
    };

    patched = true;

    return true;
};

const sectionCallBack = () => {
    if (patchScrollTop()) return;

    window.addEventListener('load', patchScrollTop, { once: true });
};

export { sectionSelector, sectionCallBack };
